import React, { useState } from 'react';
import './Product.css'; // import the refactored CSS
import './FeaturedProducts.css';
import { FaRegHeart } from 'react-icons/fa';
import { TbShoppingBag } from "react-icons/tb";
import { IoEyeOutline } from "react-icons/io5";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";

import { useNavigate } from 'react-router-dom';
import ProductCardpop from '../Product-quick-view/quickview';

const ProductCardmy = ({ product }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const navigate = useNavigate();

  const handleQuickView = (product, event) => {
    event.stopPropagation(); // Prevent navigation when clicking the eye
    setSelectedProduct(product);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedProduct(null);
  };

  const handleContainerClick = () => {
    if (!isPopupOpen) {
      navigate('/product');
    }
  };

  const { image, name, price, rating, isOnSale, isNotSale } = product;

  return (
    <>
      <div className="product-card-first" onClick={handleContainerClick} style={{ cursor: 'pointer' }}>
        <div className="product-card-first__image">
          {image ? (
            <img src={image} alt={name} className="card-img-top" />
          ) : (
            <p>No Image</p>
          )}
          {isOnSale && (
            <div className="product-card-first__sale-tag">
              <span>Sale</span>
              <span>50%</span>
            </div>
          )}
          {isNotSale && (
            <div className="product-card-second__sale-tag">
              <span>out of stock</span>
              {/* <span>50%</span> */}
            </div>
          )}

          <div className="product-card-first__actions">
            <div className="action-btn">
              <FaRegHeart size={16} />
            </div>
            <div className="action-btn action-btn--eye" onClick={(e) => handleQuickView(product, e)}>
              <IoEyeOutline size={16} />
            </div>
          </div>
        </div>

        <div className="product-card-first__info">
          <div className="product-card-first__title">{name}</div>
          <div className="product-card-first__price">${price.toFixed(2)}</div>
          <div className="product-card-first__review">
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="star-product">
                  {i < Math.round(product.average_rating)
                    ? <AiFillStar className="product-star-color" />
                    : <AiOutlineStar className="product-star-color" />}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="product-card-first__add-to-cart">
          <TbShoppingBag size={20} className='bag' />
        </div>
      </div>

      {/* 🟢 POPUP - send selectedProduct prop */}
      {isPopupOpen && selectedProduct && (
        <ProductCardpop
          isOpen={isPopupOpen}
          onClose={closePopup}
          product={selectedProduct}
        />
      )}
    </>
  );
};

export default ProductCardmy;
